/**
 * Geo Endpoints
 * SUPERADMIN: Geographic master data APIs (regions, states, cities, geo-groups)
 *
 * NOTE: Do NOT include 'v1/' prefix - the base URL already contains it.
 * Correct: 'geo/get-region'
 * Wrong:   'v1/geo/get-region'
 */
export const GEO_ENDPOINTS = {

  // Countries

  getCountries: 'geo/get-country',
  createCountry: 'geo/create-country',
  updateCountry: 'geo/update-country',
  deleteCountry: 'geo/delete-country',
  // Regions
  getRegions: 'geo/get-region',
  createRegion: 'geo/create-region',
  updateRegion: 'geo/update-region',
  deleteRegion: 'geo/delete-region',

  // States
  getStates: 'geo/get-state',
  createState: 'geo/create-state',
  updateState: 'geo/update-state',
  deleteState: 'geo/delete-state',

  // Cities
  getCities: 'geo/get-city',
  createCity: 'geo/create-city',
  updateCity: 'geo/update-city',
  deleteCity: 'geo/delete-city',
  importCities: 'geo/import-city',

  // Geo Groups
  getGeoGroups: 'geo/get-geo-group',
  getGeoHierarchy: 'geo/get-geo-hierarchy',
  createGeoGroup: 'geo/create-geo-group',
  updateGeoGroup: 'geo/update-geo-group',
  deleteGeoGroup: 'geo/delete-geo-group',
  

  
};
